import React, { forwardRef, useContext } from "react"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Col, Form, Input, Modal, notification, Row, Space } from "antd"
import { EditableList } from "../../compnents/list/EditableList"
import { AcceptanceBusinessColumns, ProcurementColumns, SearchColumns } from "./columns"
import { unwrapResult } from "@reduxjs/toolkit"
import { RootDispatch } from "../../app/store"
import { TabBar, TabPane } from "../../compnents/widgets/TabBar"
import styles from "./appllication.module.css"
import { ThemeContext } from "../../theme/ThemeContext"
import moment from "moment"
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
} from "../../models/datetime"
import { AcceptanceQuery, ProcurementQuery } from "./Query"
import { Category, CategoryName } from "../../models/category"
import { selectChainId, selectTenantId } from "../../app/applicationSlice"
import {
    getAcceptancePageAsync,
  getchainInventoryReceiptslist,
  getInsertInptPoFn,
  getInventorypurchaseacceptancemainWithdrawFn,
  getPurchaseBusinessListFn,
  getRemoveAcceptanceAsync,
  getRemoveReceiptsFn,
  queryInboundDAsync,
  queryInboundOperateInventoryFn,
} from "./chainSlice"
import { ExclamationCircleFilled } from "@ant-design/icons"
import { useHistory, useLocation } from "react-router-dom"
import { traceRoute } from "../../layouts/layoutSlice"
import { DateRangeType, getDateRange } from "../../compnents/form/DateSelect"
import { AcceptanceModal } from "./AcceptanceModal"
import { StorageModal } from "./StorageModal"
import { NavBar } from "../../compnents/nav/NavBar"

export const AcceptanceBusinessRef = () => {
  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const history = useHistory()

  const location: any = useLocation()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const dispatch = useDispatch<RootDispatch>()

  const [params, setParams] = useState<any>({ current: 1, size: 10 })

  const [page, setPage] = useState<any>({ items: [], total: 0 })

  const [pageLoading, setPageLoading] = useState(false)

  const [searchVisible, setSearchVisible] = useState(false)

  const [acceptanceVisible, setAcceptanceVisible] = useState(false)

  const [storageVisible, setStorageVisible] = useState(false)

  const [searchParams, setSearchParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [searchPage, setSearchPage] = useState<any>({ items: [], total: 0 })

  const [pageSearchLoading, setPageSearchLoading] = useState(false)

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [rowData, setRowData] = useState<any>({})

  useEffect(() => {
    if (params.current != 0) {
      getPageList()
    }
  }, [params])

  const getPageList = () => {
    setPageLoading(true)
    dispatch(
      getAcceptancePageAsync({
        timeHead,
        timeTail,
        ...params,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  return (
    <Col
      style={{
        borderRadius: 10,
        display: "flex",
        flexDirection: "column",
        height: "calc(100% - 0px)",
        overflow: "hidden",
        margin: "0px 20px",
      }}
    >
      <Col
        style={{
          margin: "10px 0px",
        }}
      >
        <NavBar
          where={[
            "库房业务",
            "验收业务"
          ]}
          backtrace={{
            name: "库房工作站",
            path: "/storage/station",
            state: { category: location?.state?.category },
          }}
        />
      </Col>
      <Col
        style={{
          height: "calc(100% - 20px)",
          margin: "10px 0",
          padding: "20px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <AcceptanceQuery
          onValueChange={(v: any) => {
            setParams({
              ...params,
              ...v,
              current: 1,
              timeHead: v?.timeHead ? v?.timeHead : timeHead,
              timeTail: v?.timeTail ? v?.timeTail : timeTail,
            })
          }}
        />
        <EditableList
          style={{ flex: 1 }}
          scroll={{ x: "40rem" }}
          loading={pageLoading}
          page={{
            items: page.items,
            current: params.current,
            size: params.size,
            total: page.total,
          }}
          onRow={(r) => ({
            onDoubleClick: () => {
              history.push({
                pathname: '/chainPutList',
                state: {
                  where: ["GSP业务", "验收业务"],
                  name: "单据列表",
                  backName: '库房工作站',
                  path:"/acceptanceBusiness",
                  category: Category.YSYW,
                  selectId: r.id,
                  detail: { ...r },
                  approvedUserName: r?.approvedUserName,
                },
              })
            },
          })}
          pageSizeOptions={["10", "20", "50", "100"]}
          rowKey={(m: any) => m.id}
          columns={AcceptanceBusinessColumns(
            params.size * (params.current - 1),
            (action: any, t: any) => {
              switch (action) {
                case "list":
                  setParams({ ...params })
                  break
                case "delete":
                  Modal.confirm({
                    centered: true,
                    title: "确认操作",
                    content: (
                      <div>
                        <ExclamationCircleFilled
                          style={{ color: "#FFAE55", fontSize: 18 }}
                        />
                        &nbsp;是否确认删除？
                      </div>
                    ),
                    okText: "确认",
                    cancelText: "取消",
                    icon: null,
                    onOk: () => {
                      dispatch(getRemoveAcceptanceAsync(t.id))
                        .then(unwrapResult)
                        .then(() => {
                          notification.success({
                            message: "删除成功",
                          })
                          setParams({ ...params })
                        })
                    },
                  })
                  break
                  case 'revocation':
                    Modal.confirm({
                      centered: true,
                      title: '确认操作',
                      content: (
                        <div>
                          <ExclamationCircleFilled
                            style={{ color: '#FFAE55', fontSize: 18 }}
                          />
                          &nbsp;是否确认撤回？
                        </div>
                      ),
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(getInventorypurchaseacceptancemainWithdrawFn(t.id))
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({
                              message: '撤回成功',
                            })
                            setParams({ ...params })
                          })
                      },
                    })
                    break
                case "storage":
                  setRowData(t)
                  setStorageVisible(true)
                  break
              }
            }
          )}
          onChangePage={(current, size) =>
            setParams({ ...params, current, size: size || 10 })
          }
          sticky
        />
      </Col>

      <StorageModal
        data={rowData}
        visible={storageVisible}
        category={Category.YSYW}
        onCancel={() => setStorageVisible(false)}
        onOk={() => {
          setStorageVisible(false)
          setParams({ ...params, current: 1 })
        }}
      />
    </Col>
  )
}

export const AcceptanceBusiness = forwardRef(AcceptanceBusinessRef)
